<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
         _/                                                                                                                    _/
         _/      子画面定義：アカウント通知内容画面(STDSDC02C04)                                                               _/
         _/                                                                                                                    _/
         _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isProcessShow">
    <div class="popup" style="width: 855px">
      <div class="popup-head">事業者アカウントの通知</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
        <p>
          以下の内容で各宛先に事業者アカウントを通知します。必要に応じて、件名やメール本文を編集してください。
        </p>
        <div class="frm-row">
          <span class="frm-label w-50px">
            <strong>件名</strong>
          </span>
          <input
            tabindex="0"
            type="text"
            class="frm-text frm-size-full"
            v-model="mailInfo.subject"
            maxlength="255"
            v-bind:class="{ error: isErrorSubject }"
            ref="subjectName"
          />
        </div>
        <p
          class="errMsg"
          style="margin-left: 60px"
          v-show="errors_subject != ''"
        >
          <ErrorMessageCase :errors="errors_subject"></ErrorMessageCase>
        </p>
        <div class="frm-row flexalignstart">
          <span class="frm-label w-50px">
            <strong>本文</strong>
          </span>
          <div class="frm-col">
            <div class="frm-item">
              <span class="frm-label">
                <span class="em">{{ strConst1 }}</span
                >様
              </span>
            </div>
            <div class="frm-item">
              <textarea
                tabindex="0"
                class="frm-text frm-size-full"
                rows="2"
                maxlength="2000"
                v-model="mailInfo.body"
                v-bind:class="{ error: isErrorBody }"
              >
              </textarea>
            </div>
            <p class="errMsg" v-show="errors_body != ''">
              <ErrorMessageCase :errors="errors_body"></ErrorMessageCase>
            </p>
            <div class="frm-item">
              <ul class="label-list">
                <li>
                  <span class="label-list-label w-100px colon">事業者ID</span>
                  <span class="em">{{ strBopId }}</span>
                </li>
                <li>
                  <span class="label-list-label w-100px colon">パスワード</span>
                  <span class="em">{{ strPassword }}</span>
                </li>
                <li>
                  <span class="label-list-label w-100px colon"
                    >ログインURL</span
                  >
                  <span class="em">{{ loginUrl }}</span>
                </li>
              </ul>
            </div>
            <div class="frm-item">
              <textarea
                tabindex="0"
                class="frm-text frm-size-full"
                rows="8"
                maxlength="2000"
                v-model="mailInfo.bodySignature"
                v-bind:class="{ error: isErrorBodySignature }"
                ref="bodySignature"
              >
              </textarea>
            </div>
            <p class="errMsg" v-show="errors_bodySignature != ''">
              <ErrorMessageCase
                :errors="errors_bodySignature"
              ></ErrorMessageCase>
            </p>
          </div>
        </div>
      </div>
      <div class="popup-foot blue">
        <div class="footer-btn">
          <p class="aligncenter">
            <label class="frm-checkbox">
              <input
                type="checkbox"
                v-model="mailInfo.accountingOfficeNotification"
              />
              <span
                tabindex="0"
                class="checkbox-item"
                @keydown.space.stop.prevent="
                  mailInfo.accountingOfficeNotification =
                    !mailInfo.accountingOfficeNotification
                "
              ></span>
              <span class="checkbox-text">
                この通知を税理士事務所メールアドレスにも送信する
              </span>
            </label>
          </p>
          <p
            class="errMsg"
            style="margin-left: 60px"
            v-show="errors_accountingOfficeNotification != ''"
          >
            <ErrorMessageCase
              :errors="errors_accountingOfficeNotification"
            ></ErrorMessageCase>
          </p>
          <div class="frm-btn-row">
            <div class="frm-item grow center">
              <button tabindex="0" class="frm-btn strong large" @click="send">
                通知する
              </button>
              <button tabindex="0" class="frm-btn large" @click="cancelSend">
                キャンセル
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import Common from "@/util/common.js";
import Validation from "@/util/validation.js";
import BaseModal from "@/components/Base/BaseModal.vue";
export default {
  name: "AccountNotificationContentModal",
  components: {
    ErrorMessage,
    ErrorMessageCase,
    BaseModal,
  },
  data() {
    return {
      errors: [],
      errors_subject: [], // エラー情報_件名
      errors_body: [], // エラー情報_本文上段
      errors_bodySignature: [], // エラー情報_本文下段
      errors_accountingOfficeNotification: [],
      isErrorSubject: false,
      isErrorBody: false,
      isErrorBodySignature: false,
      isErrorAccountingOfficeNotification: false,
      strConst1: "",
      strBopId: "",
      strPassword: "",
      strEmailAddress: "",
      loginUrl: "",
      mailInfo: {
        subject: "", // 件名
        body: "", // 本文上段
        bodySignature: "", // 本文下段
        accountingOfficeNotification: true, // 税理士事務所通知チェック
      },
    };
  },
  props: {
    isProcessShow: {
      type: Boolean,
      required: true,
    },
    //利用者メールアドレス
    bopEmailAddress: {
      type: String,
      required: true,
    },
    // 税理士事務所通知先メールアドレス
    accountingEmailAddress: {
      type: String,
      required: true,
    },
    // 通知宛先(0:税理士事務所 1:事業者)
    notificationAddress: {
      type: Number,
      required: true,
    },
    // 税理士事務所名
    accountingOfficeName: {
      type: String,
      required: true,
    },
    // 事業者名
    businessOperatorName: {
      type: String,
      required: false,
    },
    // 利用者名
    bopUserName: {
      type: String,
      required: false,
    },
  },
  mounted() {},
  computed: {},
  watch: {
    isProcessShow: function (newVal) {
      if (newVal) {
        this.reset();
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    // **********************************************
    // 送信が選択された時の処理
    // **********************************************
    send() {
      this.errors = [];
      this.errors_subject = []; // エラー情報_件名
      this.errors_body = []; // エラー情報_本文上段
      this.errors_bodySignature = []; // エラー情報_本文下段

      // -------- 件名チェック --------
      this.isErrorSubject = false;

      // 必須チェック
      if (!this.mailInfo.subject.replace("\n", "")) {
        this.isErrorSubject = true;
        this.errors_subject.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["件名"])
          )
        );
        // 入力禁止文字チェック
      } else if (Validation.containsHalfKatakana(this.mailInfo.subject)) {
        this.isErrorSubject = true;
        this.errors_subject.push(
          Common.createError(
            "MTCL1018",
            Common.getMessage("MTCL1018", ["件名", "半角カタカナ"])
          )
        );
      }

      // -------- 本文上段チェック --------
      this.isErrorBody = false;

      // 必須チェック
      if (!this.mailInfo.body.replace("\n", "")) {
        this.isErrorBody = true;
        this.errors_body.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["本文上段"])
          )
        );

        // 入力禁止文字チェック
      } else if (Validation.containsHalfKatakana(this.mailInfo.body)) {
        this.isErrorBody = true;
        this.errors_body.push(
          Common.createError(
            "MTCL1018",
            Common.getMessage("MTCL1018", ["本文上段", "半角カタカナ"])
          )
        );
      }

      // -------- 本文下段チェック --------
      this.isErrorBodySignature = false;

      // 必須チェック
      if (!this.mailInfo.bodySignature.replace("\n", "")) {
        this.isErrorBodySignature = true;
        this.errors_bodySignature.push(
          Common.createError(
            "MTCL1001",
            Common.getMessage("MTCL1001", ["本文下段"])
          )
        );
        // 入力禁止文字チェック
      } else if (Validation.containsHalfKatakana(this.mailInfo.bodySignature)) {
        this.isErrorBodySignature = true;
        this.errors_bodySignature.push(
          Common.createError(
            "MTCL1018",
            Common.getMessage("MTCL1018", ["本文下段", "半角カタカナ"])
          )
        );
      }

      // -------- 税理士事務所通知チェック--------
      this.isErrorAccountingOfficeNotification = false;
      if (this.mailInfo.accountingOfficeNotification) {
        if (!this.accountingEmailAddress.replace("\n", "")) {
          this.isErrorAccountingOfficeNotification = true;
          this.errors_accountingOfficeNotification.push(
            Common.createError("MTCL1033", Common.getMessage("MTCL1033", []))
          );
        }
      }

      if (
        this.isErrorSubject ||
        this.isErrorBody ||
        this.isErrorBodySignature ||
        this.isErrorAccountingOfficeNotification
      ) {
        this.errors.push(
          Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
        );
        return;
      }

      // メール送信
      this.$emit("send", this.mailInfo);
    },
    // **********************************************
    // キャンセルが選択された時の処理
    // **********************************************
    cancelSend() {
      this.$emit("cancelSend");
      this.reset();
    },
    // **********************************************
    // リセット
    // **********************************************
    reset() {
      // 件名
      if (this.notificationAddress === 0) {
        this.strEmailAddress = this.accountingEmailAddress;
        this.mailInfo.subject =
          Common.getMessage("MTCL2043", [this.accountingOfficeName]) +
          "　" +
          this.businessOperatorName +
          "(" +
          this.bopUserName +
          "　様" +
          ")";
      } else {
        this.strEmailAddress = this.bopEmailAddress;
        this.mailInfo.subject = Common.getMessage("MTCL2043", [
          this.accountingOfficeName,
        ]);
      }
      this.strConst1 = Common.getMessage("MTCL2094", [""]);
      this.strBopId = Common.getMessage("MTCL2046", []);
      this.strPassword = Common.getMessage("MTCL2047", []);
      this.loginUrl = Common.getMessage("MTCL2013", []);
      this.strEmailAddress = this.bopEmailAddress;
      this.mailInfo.body = Common.getMessage("MTCL2044", []); // 本文上段
      this.mailInfo.bodySignature =  Common.getMessage("MTCL2167", []) + Common.getMessage("MTCL2015", []); // 本文下段
      this.mailInfo.accountingOfficeNotification = true; // 税理士事務所通知チェック
      this.errors = [];
      this.errors_subject = []; // エラー情報_件名
      this.errors_body = []; // エラー情報_本文上段
      this.errors_bodySignature = []; // エラー情報_本文下段
      this.errors_accountingOfficeNotification = [];
      this.isErrorSubject = false;
      this.isErrorBody = false;
      this.isErrorBodySignature = false;
      this.isErrorAccountingOfficeNotification = false;
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.subjectName.focus();
    },
  },
};
</script>
